import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/search_icon.svg'


const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_localizedPlaceholder = _resolveDirective("localizedPlaceholder")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives(_createElementVNode("input", {
      type: "text",
      class: _normalizeClass(_ctx.inputClass ? _ctx.inputClass : ''),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localInput) = $event)),
      id: "google_autocomplete_province",
      onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteText())),
      autocomplete: "off",
      autofocus: ""
    }, null, 34), [
      [_directive_localizedPlaceholder, {key: _ctx.placeholderKey, value: _ctx.placeholderText}],
      [_vModelText, _ctx.localInput]
    ])
  ]))
}